<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 65">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <path class="fill" d="M56 56c1.473 0 2.667 1.194 2.667 2.667 0 1.367-1.03 2.494-2.356 2.648l-.311.018H8c-1.473 0-2.667-1.194-2.667-2.666 0-1.368 1.03-2.495 2.356-2.65L8 56h48zM35.448 3.448c1.041-1.042 2.73-1.042 3.771 0l10.667 10.666c1.041 1.042 1.041 2.73 0 3.772L20.552 47.219c-.5.5-1.178.781-1.885.781H8c-1.473 0-2.667-1.194-2.667-2.667V34.667c0-.708.281-1.386.781-1.886zm1.885 5.659L10.667 35.77v6.896h6.89L44.227 16l-6.894-6.893z" transform="translate(-642 -271) translate(642 271)"/>
            </g>
        </g>
    </g>
</svg>
